import { useEffect } from "react";
import { usePersistedEmployeeId } from "./usePersistedEmployeeId";

export function useEnableGroupAccount(isGroupAccount: boolean) {
  const { setCurrentEmployeeId, currentEmployeeId } = usePersistedEmployeeId();
  useEffect(() => {
    if (!isGroupAccount && currentEmployeeId) {
      setCurrentEmployeeId(undefined);
    }
  }, [isGroupAccount, currentEmployeeId, setCurrentEmployeeId]);
}
